var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewIcon = function SvgReviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8 8.604 1.267.767a.31.31 0 0 0 .367-.008.3.3 0 0 0 .133-.342l-.333-1.45 1.133-.983q.167-.15.1-.358-.066-.208-.3-.226l-1.483-.116-.583-1.367a.3.3 0 0 0-.3-.2.3.3 0 0 0-.3.2l-.584 1.367-1.483.116q-.234.018-.3.226a.32.32 0 0 0 .1.358l1.133.983-.333 1.45a.3.3 0 0 0 .133.342.31.31 0 0 0 .367.008zm-4 3.684L2.468 13.82q-.316.316-.725.142-.408-.174-.408-.625V2.954q0-.55.392-.94.392-.392.941-.393h10.667q.55 0 .942.392t.391.941v8q0 .55-.391.942a1.28 1.28 0 0 1-.942.392zm-.566-1.334h9.9v-8H2.667v8.75z"
  })));
};
export default SvgReviewIcon;